interface SkillsItemProps {
  label: string;
}

export const SkillsItem = ({ label }: SkillsItemProps) => {
  return (
    <div className="bg-green-100 text-emerald-700 border border-emerald-300 rounded-full py-1  px-2 text-sm">
      {label}
    </div>
  );
};
